import { TIconProps } from './utils';

export const AccountIconHover = ({ className = '' }: TIconProps) => (
  <svg
    width='46'
    height='46'
    viewBox='0 0 46 46'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M23.5746 10.3501C27.9829 10.3501 31.6715 13.7515 31.6715 18.0033C31.6715 20.5543 30.3221 22.8503 28.1629 24.2108C32.7511 25.8265 36.1698 29.7381 36.7996 34.5001H34.4605C33.7408 29.398 29.0625 25.5714 23.5746 25.5714C18.0867 25.5714 13.4085 29.398 12.6887 34.5001H10.3496C10.9794 29.7381 14.3981 25.8265 18.9863 24.2108C16.8272 22.8503 15.4777 20.5543 15.4777 18.0033C15.4777 13.7515 19.1663 10.3501 23.5746 10.3501ZM23.5746 12.476C20.3358 12.476 17.8168 14.942 17.8168 18.0033C17.8168 20.9795 20.3358 23.4455 23.5746 23.4455C26.8134 23.4455 29.3324 20.9795 29.3324 18.0033C29.3324 14.942 26.8134 12.476 23.5746 12.476Z'
      fill='url(#paint0_linear_2181_47070)'
      stroke='url(#paint1_linear_2181_47070)'
      strokeWidth='0.4'
    />
    <defs>
      <linearGradient
        id='paint0_linear_2181_47070'
        x1='8.09168'
        y1='1.08324'
        x2='45.0486'
        y2='11.9679'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#B36BFF' />
        <stop offset='1' stopColor='#5A75FF' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_2181_47070'
        x1='8.09168'
        y1='1.08324'
        x2='45.0486'
        y2='11.9679'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#B36BFF' />
        <stop offset='1' stopColor='#5A75FF' />
      </linearGradient>
    </defs>
  </svg>
);
